import { t } from "@repo/translation";
import { type Toast } from "@repo/utils";

import { logError } from "../error";
import type { Customer, CustomerData, CustomerSearchError } from "./types";

const isSuccess = (
  response: CustomerData | CustomerSearchError | undefined
): response is CustomerData => {
  if ((response as any)?.customerSelection) {
    return true;
  }

  return false;
};

const isError = (
  response: CustomerData | CustomerSearchError | undefined
): response is CustomerSearchError => {
  if ((response as any)?.success === false) {
    return true;
  }

  return false;
};

const setCustomerData = (response: CustomerData) => {
  window?.salja?.customerProfile?.setCustomerData?.(response);

  openCustomerInformationModal();
};

const openCustomerInformationModal = () => {
  window?.salja?.customerProfile?.openCustomerInformationModal?.();
};

export const getCustomerDetails = (
  partyId: string,
  market: string,
  customerType: Customer["customerType"],
  updateToast: (toast: Toast) => void
) => {
  if (!window?.salja?.customerProfile?.searchCustomer) {
    return Promise.resolve().then(() => {
      updateToast({
        title: t("prompt.customer_profile_not_available"),
        type: "error",
      });
    });
  } else {
    return window.salja.customerProfile
      .searchCustomer(
        {
          partyUID: partyId,
          customerType: customerType === "Business" ? "Business" : "PRIVATE",
        },
        market
      )
      .then((response: CustomerData | CustomerSearchError | undefined) => {
        if (isSuccess(response)) {
          setCustomerData(response);
        } else if (isError(response)) {
          updateToast({
            id: partyId,
            title: t("prompt.customer_not_found_error", {
              errorMessage: response?.error?.message,
            }),
            type: "error",
          });

          logError(
            response?.error ||
              response?.error?.message ||
              "Failed to get Customer data: Malformed error object"
          );
        } else {
          updateToast({
            id: partyId,
            title: t("prompt.customer_not_found_error", {
              errorMessage: "undefined error",
            }),
            type: "error",
          });

          logError("Failed to get Customer data: undefined error");
        }
        return response;
      })
      .catch((error) => {
        logError(error);
      });
  }
};
